import * as React from "react";

function SvgClearDropLocation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M4.307 15.606H0c.266-5.06 3.306-9.877 6.936-12.46C9.299 1.46 12.219.235 15.316 0l.001 1.022c.002 1.174.004 2.837-.001 3.33-1.647.21-2.97.67-4.276 1.333-3.54 1.793-6.365 5.602-6.733 9.92zM6.77 24.588a.239.239 0 01.033.027c.089.414 1.298 1.601 1.57 1.83 1.983 1.66 4.1 2.961 6.956 3.197v4.352c-8.026-.62-14.81-7.42-15.316-15.6l4.307-.045c.12 1.825.754 3.414 1.558 4.939.116.222.227.402.357.612l.036.058.412.567.015.01a.36.36 0 01.048.035.168.168 0 00.023.018zM9.52 15.606h5.809l-.013-5.991c-2.806.491-5.384 3.056-5.796 5.99zM12.771 23.321a9.877 9.877 0 01.946-4.932l-4.184.005c.336 1.678 1.109 2.967 1.938 3.866.3.326.756.709 1.3 1.061zM18.67 31.745L18.673 34a15.997 15.997 0 005.754-1.572 9.98 9.98 0 01-5.757-.683zM32.443 24.338A16.204 16.204 0 0033.99 18.4l-2.378-.02a9.878 9.878 0 01.972 4.287c0 .57-.048 1.128-.14 1.671zM23.35 12.773c-1.098-1.617-2.836-2.826-4.67-3.152l-.005 3.965a9.882 9.882 0 014.675-.813zM29.686 15.612H34c-.272-5.06-3.313-9.87-6.942-12.454-2.363-1.684-5.277-2.91-8.38-3.152l-.001 1.024c-.002 1.174-.004 2.84 0 3.328 1.648.21 2.978.67 4.283 1.333 3.54 1.8 6.36 5.602 6.726 9.921z"
        fill="current"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.667 34C28.926 34 34 28.926 34 22.667c0-6.26-5.074-11.334-11.333-11.334-6.26 0-11.334 5.074-11.334 11.334C11.333 28.926 16.407 34 22.667 34zm0-1.417c5.476 0 9.916-4.44 9.916-9.916 0-5.477-4.44-9.917-9.916-9.917-5.477 0-9.917 4.44-9.917 9.917 0 5.476 4.44 9.916 9.917 9.916z"
        fill="current"
      />
      <path
        d="M22.667 24.367l3.966 3.966 1.7-1.7-3.966-3.966 3.966-3.967-1.7-1.7-3.966 3.967L18.7 17 17 18.7l3.967 3.967L17 26.633l1.7 1.7 3.967-3.966z"
        fill="current"
      />
    </svg>
  );
}

export default SvgClearDropLocation;
